const DELETION_STATUSES = {
  ALL: 'all',
  ACTIVE: 'active',
  DEACTIVATED: 'deactivated',
  DELETED: 'deleted',
};

export default DELETION_STATUSES;
